import React from "react";
import { CSSTransition } from "react-transition-group";

export default function Fade({ toggle, timeout, children }) {
  return (
    (toggle && (
      <CSSTransition in={toggle} timeout={timeout} classNames="fade">
        {/* {Inject fade className to child} */}
        {React.cloneElement(children, {
          className: `${
            children.props.className ? children.props.className : ""
          } fade`,
        })}
      </CSSTransition>
    )) ||
    null
  );
}
